<template>
	<div class="main" v-loading="list_loading">
		<mybread></mybread>
		<el-table :data="kykList" border style="width: 100%">
			<el-table-column prop="id" label="id" width="180">
			</el-table-column>
			<el-table-column prop="gatewayNumber" label="网关编号" width="180">
			</el-table-column>
			<el-table-column prop="elderType" label="老人类型">
			</el-table-column>
			<el-table-column prop="type" label="报警类型">
			</el-table-column>
			<el-table-column prop="alarmTime" label="报警时间">
			</el-table-column>
		</el-table>
		<div class="block">
			<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" background @size-change="handleSizeChange" :page-sizes='[5,10,20]' :page-size='pageSize' layout="sizes, prev,pager, next,total,jumper" :total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import mybread from "@/components/bread"
	export default {
		components: {
			mybread
		},
		data() {
			return {
				kykList: [],
				total: 0, //总页数
				pageSize: 10, //每页条数
				currentPage: 1, //当前页（默认第一页）
				list_loading:true
			}
		},
		created() {
			this.getKykList()
		},
		methods: {
			handleCurrentChange(val) {
				this.currentPage = val; //获取当前页
				this.getKykList();
			},
			handleSizeChange(psize) { //选择每页条数
				this.pageSize = psize;
				this.getKykList();
			},
			getKykList() {
				let data = new FormData();
				data.append('length',this.pageSize);
				data.append('start',(this.currentPage - 1) * this.pageSize);
				this.$post("api/KykPushList", data).then(res => {
					this.kykList = res.data
					this.total = res.recordsFiltered
					this.list_loading=false
					this.kykList.map(function(val) {
						switch(val.elderType){
							case '1':
							val.elderType = "老人1";
							break;
							case '2':
							val.elderType = "老人2";
							break;
						}
					})
					this.kykList.map(function(val){
						switch(val.type){
							case '1':
							val.type="床头呼叫";
							break
							case '2':
							val.type="挂绳呼叫";
							break
						}
					});
				}).catch((e) => {
					window.console.log(e)
				})
				

				},
			},
		}
</script>

<style scoped="scoped">
	.block {
		text-align: center;
		margin-top: 20px;
	}

	.main {
		background: #fff;
		padding: 0 20px 20px 20px;
	}
</style>
